import React, { useState } from 'react';
import CaseForm from './Forms/CaseForm';
import apiService from '../../axios/apiService';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { BAD_REQUEST_STATUS_CODE } from '../../axios/constants';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/created' },
  { label: 'Add', to: '/user/case/add' },
];
const AddCase = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [api, contentHolder] = notification.useNotification();

  const handleSubmit = async (data, _loading = "saving") => {
    setLoading(_loading);
    try {
      const response = await apiService.createCase(data);
      api.success({
        message: 'Success',
        description: response?.message,
        showProgress: false,
      });
      navigate('/user/case/created');
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error?.response?.status === BAD_REQUEST_STATUS_CODE &&
        !error?.response?.data?.formErrorMessage
      )
        return;
      api.error({
        message: 'Error',
        description: error?.response?.data?.error || error?.message,
        showProgress: false,
      });
    } finally {
      setLoading(undefined);
    }
  };

  return (
    <>
      {contentHolder}
      <CaseForm
        loading={loading}
        onSubmit={handleSubmit}
        breadCrumbs={BREAD_CRUMBS}
      />
    </>
  );
};

export default AddCase;
